export default function MounthlyMeeting() {

    const am = [
        {
            "event_date": "Wednesday, September 20, 2023 12:00-1:30 P.M.", 
            "event_location": "New Rochelle Public Library",
            "event_name": "Opening Meeting",
            "event_details": "Kick-off the 2023-2024 programming year with our members. Guest speakers: TBA"
        },
    
        {
            "event_date": "Wednesday, October 18, 2023 5:30-7.00 P.M.", 
            "event_location": "Location: TBA",
            "event_name": "Symposium - Affordable Housing",
            "event_details": "Panelists: TBA"
        },
    
        {
            "event_date": "Wednesday, November 15, 2023 12:00-1:30 P.M.", 
            "event_location": "Zoom Link to be sent",
            "event_name": "Monthly Meeting - Member Roundtable",
            "event_details": "Members share ideas, programs, and activities"
        },
    
        {
            "event_date": "Wednesday, January 17, 2024 5:30-7:00 P.M.", 
            "event_location": "Location: TBA",
            "event_name": "Symposium - Intergenerational Services & Programs",
            "event_details": "Panelists: TBA"
        },
    
        {
            "event_date": "Wednesday, February 28, 2024 12:00-1:30 P.M.", 
            "event_location": "Location: TBA",
            "event_name": "Monthly Meeting - Member Showcase",
            "event_details": "One of our members agrees to host our meeting to showcase their facilities, programs, services and impact"
        },
    
        {
            "event_date": "Wednesday, March 20, 2024 12:00-1:30 P.M.", 
            "event_location": "Zoom Link to be sent",
            "event_name": "Monthly Meeting - Member Roundtable",
            "event_details": "Members share ideas, programs, and activities"
        },
    
        {
            "event_date": "Wednesday, April 17, 2023 9:00-10:30 A.M.", 
            "event_location": "Davenport Mansion",
            "event_name": "NRCCS Breakfast Honoring Community Champions and Scholarship Award Recipients",
            "event_details": "" /* no details provided*/
        },
    
        {
            "event_date": "Wednesday, May 15, 2024", 
            "event_location": "Time, location, participants TBA",
            "event_name": "Health and Wellness Fair",
            "event_details": "A festive event featuring NR community health and wellness services and programs"
        },
    
        {
            "event_date": "Wednesday, June 19, 2023 12:00-1:30 P.M.", 
            "event_location": "Location: TBA",
            "event_name": "Closing Networking Reception",
            "event_details": "" /* no details provided*/
        } 
    ]
    
    return (
        <div className="lg:p-24 p-6 flex flex-col lg:gap-12 gap-4">
            <div className="">
                <h2 className="lg:text-4xl text-xl lg:text-center font-bold">New Rochelle <span className="text-yellow-400">Council</span>  of Community <span className="text-purple-800">Services</span> </h2>
                <p className="lg:text-center pt-4 font-semibold text-gray-600 text-lg">2023-2024 Calendar of Meetings and Events</p>
            </div>

            <div className="lg:text-center pb-4 font-bold text-purple-800 max-w-5xl mx-auto">

                As we anticipate the upcoming programming year, the NRCCS Executive Board will be reacing out to our member organizations this 
                summer to elicit input on this calendar of events and the revamping of the NRCCS website. We look forward to engaging conversations. Please direct questions
                or comments to Karenann Carty at <span className="underline">

                        <a href="tel:(914) 879-3521">
                            (914) 879-3521
                        </a>
                    </span>  or <span className="underline">
                    <a href="mailto:kcarty@monroecollege.edu">
                        kcarty@monroecollege.edu
                    </a>
                </span>.
            
            </div>

            <div className="lg:grid lg:grid-cols-2 gap-2 flex flex-col border">
                {am.map((item, index) => (
                    <div key={index} className="borderrounded-lg overflow-hidden">
                        <div className="col-span-3 p-4 flex flex-col gap-1.5">
                            <p className="text-purple-800 font-semibold">{item.event_date}</p>
                            <p className="italic">{item.event_location}</p>
                            <p className="font-bold">{item.event_name}</p>
                            <p className="text-gray-500  text-sm">{item.event_details}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}